import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./goal-description-field.i18n";

/** QP-187 — server-enforced cap (goal.description varchar(150)). */
export const GOAL_DESCRIPTION_MAX_LENGTH = 150;

type GoalDescriptionFieldProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

/** QP-187 — the optional goal description with its live character counter. */
export function GoalDescriptionField({
  id,
  value,
  onChange,
  disabled = false,
}: GoalDescriptionFieldProps) {
  const t = useT(T);
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{t.goalDescription}</Label>
      <Textarea
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value.slice(0, GOAL_DESCRIPTION_MAX_LENGTH))}
        placeholder={t.goalDescriptionPlaceholder}
        maxLength={GOAL_DESCRIPTION_MAX_LENGTH}
        rows={3}
        disabled={disabled}
      />
      <p className="text-xs text-muted-foreground text-right">
        {value.length}/{GOAL_DESCRIPTION_MAX_LENGTH}
      </p>
    </div>
  );
}
